import { ord, string } from 'fp-ts';
import {
    AccountingState,
    OrderItem,
    PaymentCardState,
    PaymentPlan,
    PaymentPlanDetailResult,
    PaymentPlanStatus,
    Reservation,
    ReservationLinkResult,
    SepaDirectDebitProviderState,
} from '@mews-commander/data-access';
import { createHandler } from '@mews/std';
import { TagVariant } from '@optimus-web/core';

export const getTagVariantFromPaymentPlanStatus = createHandler<PaymentPlanStatus, TagVariant>({
    Planned: 'primary',
    Active: 'success',
    Finished: 'basicBold',
    Canceled: 'danger',
});

export const isOrderItemAccountable = ({ accountingState }: OrderItem) =>
    accountingState === AccountingState.Open ||
    accountingState === AccountingState.Closed ||
    accountingState === AccountingState.Inactive;

export const sortedReservationsByStartUtc = ord.contramap((a: ReservationLinkResult) => a.reservationStartUtc)(
    string.Ord
);

export const getAccountableOrderItemByReservation = (orderItems: OrderItem[], { id }: Reservation) =>
    orderItems.filter((orderItem) => orderItem.serviceOrderId === id && isOrderItemAccountable(orderItem));

export const showNextScheduledPayment = ({
    nextPaymentAmount,
    nextPaymentDateUtc,
    nextFuturePaymentId,
    status,
}: PaymentPlanDetailResult): boolean =>
    !!(
        nextPaymentAmount &&
        nextPaymentDateUtc &&
        nextFuturePaymentId &&
        (status === PaymentPlanStatus.Active || status === PaymentPlanStatus.Planned)
    );

export const isPaymentPlanCancellable = (status: PaymentPlanStatus | undefined): boolean =>
    status === PaymentPlanStatus.Active || status === PaymentPlanStatus.Planned;

export const getEnabledPaymentMethodId = (paymentMethodData?: PaymentPlan['paymentMethodData']) =>
    paymentMethodData?.value?.state === PaymentCardState.Enabled ||
    paymentMethodData?.value?.state === SepaDirectDebitProviderState.Enabled
        ? paymentMethodData?.value?.id
        : undefined;

export const getReservationById = <TReservation extends Pick<ReservationLinkResult, 'reservationId'>>(
    reservations: TReservation[],
    reservationId: string
) => reservations.find(({ reservationId: id }) => id === reservationId);
